import { Card as AntdCard } from 'antd';
import styled, { css } from 'styled-components';
import { prop, switchProp } from 'styled-tools';
import { TemplateObjectType } from 'data/templates/api';

export const MoreActionsWrapper = styled.div`
  position: absolute;
  right: var(--spacing-03);
  top: var(--spacing-03);
  opacity: 0;
  transition: opacity var(--animation-duration-fast) ease-in;
`;

interface Props {
  private?: boolean;
}

export const TemplateCard = styled(AntdCard).attrs({
  hoverable: true,
  bordered: false,
})<Props>`
  width: 300px;
  position: relative;
  background: ${(props) =>
    props.private ? 'var(--private-01)' : 'var(--white-100)'};
  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 128px;

    .ant-typography {
      margin-bottom: 0;
    }
  }

  .ant-card-loading-content .ant-row:first-child {
    display: none;
  }

  &:hover ${MoreActionsWrapper} {
    opacity: 1;
  }
`;

export const TemplateCardIconWrapper = styled.div<{
  type?: TemplateObjectType;
}>`
  margin-bottom: var(--spacing-05);
  ${switchProp(prop('type'), {
    [TemplateObjectType.Project]: css`
      background: var(--green-10);
      border-radius: var(--border-radius-small);
    `,
    [TemplateObjectType.Document]: css`
      background: var(--blue-10);
      border-radius: var(--border-radius-small);
    `,
    [TemplateObjectType.StatusUpdates]: css`
      background: var(--teal-10);
      border-radius: var(--border-radius-small);
    `,
    [TemplateObjectType.Form]: css`
      background: var(--teal-10);
      border-radius: var(--border-radius-small);
    `,
  })};
`;
